import React from 'react';
import differenceBy from 'lodash/differenceBy';
import uniqBy from 'lodash/uniqBy';
import get from 'lodash/get';
import StatusBar from '../../../StatusBar';
import generateKey from '../../../../utils/methods/generateKey';

const CLOSED_BANNERS_STORAGE_KEY = 'pp_closedInformationBanners';
const CLOSED_BANNERS_LIFETIME = 1000 * 60 * 60 * 24 * 7; // 7 days

class RootTopSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      banners: [],
    };

    this.now = Date.now();
    this.setClosedBanners(this.getClosedBanners().filter(b => ((b.timestamp + CLOSED_BANNERS_LIFETIME) > this.now)));
  }

  componentDidMount() {
    if (window.informationBanners) {
      this.updateBanners(window.informationBanners);
      delete window.informationBanners;
    }

    window.updateInformationBanners = (banners) => {
      this.updateBanners(banners);
    };
  }

  componentWillUnmount() {
    delete window.updateInformationBanners;
  }

  getClosedBanners = () => (JSON.parse(localStorage.getItem(CLOSED_BANNERS_STORAGE_KEY) || '[]'));

  setClosedBanners = (banners) => {
    localStorage.setItem(CLOSED_BANNERS_STORAGE_KEY, JSON.stringify(banners));
  }

  updateBanners = (banners) => {
    let tmpBanners = banners.map(el => ({ ...el, id: generateKey(el) }));
    this.updateClosedBannersTimestamp(tmpBanners);
    tmpBanners = differenceBy(tmpBanners, this.getClosedBanners(), 'id'); // Removing closed banners from banners list
    this.setState({ banners: uniqBy([...this.state.banners, ...tmpBanners], 'id') });
  }

  updateClosedBannersTimestamp = (banners) => {
    this.setClosedBanners(
      this.getClosedBanners().map(banner => (
        banners.map(b => b.id).includes(banner.id)
          ? {
            ...banner,
            timestamp: this.now,
          }
          : banner
      )),
    );
  }

  sortBanners = (banners) => {
    const topBanners = banners.filter(b => b.type === 'marketing');
    const middleBanners = [
      ...banners.filter(b => b.type === 'error'),
      ...banners.filter(b => b.type === 'warning'),
      ...banners.filter(b => b.type === 'announcement'),
    ];
    const bottomBanners = banners.filter(b => b.type === 'trivial');

    return { topBanners, middleBanners, bottomBanners };
  }

  renderBanner = (banner) => {
    const statusesDict = {
      marketing: 'information',
      error: 'error',
      warning: 'warning',
      announcement: 'success',
      trivial: 'default',
    };

    return (
      <StatusBar
        type={statusesDict[banner.type]}
        key={banner.id}
        text={banner.text}
        linkText={banner.linkText}
        linkType={banner.linkType}
        onLinkClick={() => { window.open(banner.linkUrl, '_blank'); }}
        closeIcon={banner.closeButton}
        onClose={() => {
          this.setClosedBanners([...this.getClosedBanners(), { id: banner.id, timestamp: this.now }]);
          this.setState({ banners: this.state.banners.filter(b => b.id !== banner.id) });
        }}
      />
    );
  }

  render() {
    const { topBanners, middleBanners, bottomBanners } = this.sortBanners(this.state.banners);
    let newChildren = topBanners.map(this.renderBanner);

    React.Children.forEach(this.props.children, (child) => {
      newChildren.push(child);

      if (get(child, 'type.displayName') === 'ProductBar') {
        newChildren = [...newChildren, ...middleBanners.map(this.renderBanner)];
      }
    });

    newChildren = [...newChildren, ...bottomBanners.map(this.renderBanner)];

    return (<div data-ppuc-id="RootTopSection">{newChildren}</div>);
  }
}

RootTopSection.displayName = 'Root.TopSection';

export default RootTopSection;
